import { render, staticRenderFns } from "./MoveModal.vue?vue&type=template&id=2caba388&scoped=true"
import script from "./MoveModal.vue?vue&type=script&lang=ts"
export * from "./MoveModal.vue?vue&type=script&lang=ts"
import style0 from "./MoveModal.vue?vue&type=style&index=0&id=2caba388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caba388",
  null
  
)

export default component.exports